export default __webpack_public_path__ + "e-commerce377c27.jpg";